export default "__VITE_ASSET__Z4Xwus_W__ 480w, __VITE_ASSET__oMBg0Zbe__ 768w, __VITE_ASSET__CW_oLZWL__ 1200w, __VITE_ASSET__CtNaBaNB__ 1280w";